// Module
var code = `<div class="js-risk-warning-message-main ">
    <div class="js-risk-warning-message-content">
        <div class="risk-warning-message-content-row">
            <terceraLabel text="{{userNameLabel}}"/>
            <div class="value">{{UserName}}</div>
        </div>
        <div class="risk-warning-message-content-row">
            <terceraLabel text="{{accNameLabel}}"/>
            <div class="value">{{AccName}}</div>
        </div>
        <div class="risk-warning-message-content-row">
            <div class="value">{{msgText}}</div>
        </div>
    </div>
    
    <div class="js-risk-warning-message-footer">
        <terceraButton terceraButtonStyle="{{.btnStyle}}" text="{{.okText}}"  on-btnClick="okClick"/>
    </div>
</div>
`;
// Exports
export default code;